import { CommonNotePage } from "../components/CommonNotePage.js";
import { getGardenNotes } from "../scripts/notes.js";
import type { Route } from "./+types/gardenNote";
import NotFoundPage from "./NotFoundPage.js";

export async function clientLoader({ params }: Route.LoaderArgs) {
  const notes = getGardenNotes();
  const id = params.noteId;
  if (id && Object.prototype.hasOwnProperty.call(notes, id)) {
    return await notes[id]();
  }
  return null;
}
clientLoader.hydrate = true as const;

export function HydrateFallback() {
  return <></>;
}

export default function GardenNotePage({ loaderData }: Route.ComponentProps) {
  const note = loaderData;
  if (!note) return <NotFoundPage />;
  return (
    <CommonNotePage
      title={note.metadata.title}
      Content={note?.default ?? (() => <></>)}
      components={{
        h1(props) {
          return <h1 className="text-balance" {...props} />;
        },
        h2(props) {
          return <h2 className="text-balance" {...props} />;
        },
        h3(props) {
          return <h3 className="text-balance" {...props} />;
        },
      }}
    />
  );
}
